import Reveal from "@/components/Reveal";

export default function PageHero({ overline, title, sub, testId }) {
  return (
    <section className="grain relative bg-[#0F4C5C] py-14 text-white sm:py-20" data-testid={`${testId}-hero`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-[0.22em] text-[#E8A34C]" data-testid={`${testId}-overline`}>
            <span className="block h-px w-8 bg-[#E8A34C]" aria-hidden="true" />
            {overline}
          </p>
        </Reveal>
        <Reveal delay={1}>
          <h1 className="font-heading mt-4 max-w-3xl text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
            {title}
          </h1>
        </Reveal>
        {sub && (
          <Reveal delay={2}>
            <p className="mt-4 max-w-2xl text-lg text-slate-200 sm:text-xl">{sub}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
